import { isAxiosError } from "axios";
import axiosInstance from "../../utility/axiosInstance";
import { Dispatch } from "@reduxjs/toolkit";
import { setMessage } from "../../store/slices/message";
import { setLoading, stopLoading } from "../../store/slices/loading";

export interface CreateDonationData {
  fundType: string;
  amount: number;
  name: string;
  email: string;
}

export interface CaptureDonationData {
  orderID: string;
}

export const create_donation = async (
  dispatch: Dispatch<any>,
  data: CreateDonationData
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post(
      "https://ai-user-v2.onrender.com/api/v1/donation/create",
      data
    );

    // Assuming the backend returns an approval URL or similar.
    // If the backend returns a redirect URL directly, we might handle it here or return it.
    // Based on typical flows, we might get a link to redirect the user to PayPal/Stripe.

    if (
      response.data?.status === "success" &&
      response.data?.data?.approvalUrl
    ) {
      window.location.href = response.data.data.approvalUrl;
    } else {
      dispatch(
        setMessage({
          type: "error",
          title: "Donation Failed",
          message:
            response.data?.message ||
            "Unable to initiate donation at this time.",
        })
      );
    }

    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
      dispatch(
        setMessage({
          type: "error",
          title: "Donation Failed",
          message:
            error.response?.data?.message ||
            "An error occurred while initiating the donation.",
        })
      );
    }
    throw error;
  } finally {
    dispatch(stopLoading());
  }
};

export const capture_donation = async (
  dispatch: Dispatch<any>,
  data: CaptureDonationData
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post(
      "https://ai-user-v2.onrender.com/api/v1/donation/capture",
      data
    );

    dispatch(
      setMessage({
        type: "success",
        title: "Donation Successful",
        message: "Thank you for your generous donation!",
      })
    );
    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
      dispatch(
        setMessage({
          type: "error",
          title: "Capture Failed",
          message:
            error.response?.data?.message || "Failed to capture donation.",
        })
      );
    }
    throw error;
  } finally {
    dispatch(stopLoading());
  }
};
